<template>
  <el-row>
    <el-col :span="24">
      <el-checkbox-group v-model="value"  v-validate="item.isRequired  ?'required': ''" :name="item.id">
        <div v-for="(option, i) in item.body.options" :key="i">
          <el-checkbox :value="option" :label="option" style="white-space: pre-line;display: inline-flex;">{{option}}</el-checkbox>
        </div>
      </el-checkbox-group>
      <div>
        <el-checkbox :name="item.id" v-if="item.body.addOtherOption" v-model="otherChecked" @change="handleOther">Khác</el-checkbox>
      </div>
      <div style="margin-top:5px;" v-if="otherChecked">
        <el-input :name="item.body.placeholderOtherOptionPre" :placeholder="item.body.placeholderOtherOption" v-model="otherValue" @blur="handleOtherValue()" />
      </div>
      <div v-if="errors.has(item.id)" style="color:red">{{$t(`requiredChoose`)}}</div>
    </el-col>
  </el-row>
</template>
<script>
import { findIndex, map, filter } from 'lodash'
import Vue from 'vue'
export default {
  data() {
    return {
      value: [],
      otherValue: '',
      otherChecked: false
    }
  },
  inject: ['parentValidator'],
  methods: {
    sendDataSurvey(data) {
      var _this = this
      _this.$store.commit('editSurvey', data)
    },
    handleOther(val) {
      let _this = this
      if (!val) {
        _this.value = filter(_this.value, v => {
          return v.indexOf('other#') == -1
        })
      } else {
        var index = findIndex(_this.value, function(o) {
          return o.indexOf('other#') > -1
        })
        if (index == -1) {
          _this.value.push('other#' + _this.otherValue)
        }
      }
    },
    handleOtherValue() {
      var _this = this
      var index = findIndex(_this.value, function(o) {
        return o.indexOf('other#') > -1
      })
      if (index != -1) {
        Vue.set(_this.value, index, 'other#' + _this.otherValue)
      }
    }
  },
  watch: {
    value: function(val) {
      var _this = this
      _this.sendDataSurvey({ surveyDetailId: _this.item.id, values: _this.value })
    }
  },
  created() {
    var _this = this;
    this.$validator = this.parentValidator
  },
  props: ['item']
}
</script>

